import React, { useState, createContext, useContext } from 'react';

import PropTypes from 'prop-types';

const INIT_STATE = {
  booking: {},
};

const Booking = createContext(INIT_STATE);

function Provider({ children }) {
  const [state, setState] = useState(INIT_STATE);

  const actions = {
    initBooking: booking => setState({ booking }),
  };

  const value = {
    state,
    actions,
  };

  return <Booking.Provider value={value}>{children}</Booking.Provider>;
}

Provider.propTypes = {
  children: PropTypes.node,
};

export const withBookingContext = WrappedComponent =>
  function Wrapper() {
    return (
      <Provider>
        <WrappedComponent />
      </Provider>
    );
  };

export const useBookingContext = () => useContext(Booking);